import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import Footer from "../../components/Footer";
import PatientProfileMain from "./PatientProfileMain";

const PatientProfile = () => {
  return (
    <>
      <HeaderFour headerClass="it-header-area-two" />
      <PatientProfileMain />
      <Footer />
    </>
  );
};

export default PatientProfile;
